module.exports = __webpack_public_path__ + "img/overnight-parking-no.9370f336.svg";